import type { ReactNode } from "react";

import { useUser } from "@/hooks/useUser";
import type { Papel } from "@/types/api";

interface Props {
  allowed: Papel[];
  fallback?: ReactNode;
  children: ReactNode;
}

export function RoleGate({ allowed, fallback, children }: Props) {
  const { data, isLoading } = useUser();
  if (isLoading) return null;
  if (!data || !allowed.includes(data.papel)) {
    return (
      <>
        {fallback ?? (
          <div className="rounded-md border border-amber-200 bg-amber-50 p-4 text-sm text-amber-900">
            Você não tem permissão para acessar esta tela.
          </div>
        )}
      </>
    );
  }
  return <>{children}</>;
}
